import FormSelect from 'components/Select/FormSelect';
import Text from 'components/Text/Text';
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { IItemForGetShortInfo } from 'types';
import { Checkbox } from 'antd';
import SearchField from 'components/SearchField/SearchField';
import style from './MultipleSelect.module.scss';

interface IMultipleSelect {
	data: IItemForGetShortInfo[];
	setModifierGroupsAsAdditional: (value: string[]) => void;
	selectedModifierGroups: string[];
	selectedModifierGroupsAsAdditional: string[];
}

const MultipleSelect: React.FC<IMultipleSelect> = ({
	data,
	setModifierGroupsAsAdditional,
	selectedModifierGroups,
	selectedModifierGroupsAsAdditional,
}) => {
	const [searchString, setSearchString] = useState<string>('');

	const filteredData = useMemo(() => {
		return searchString ? data.filter((el) => el.name.toLowerCase().includes(searchString.toLowerCase())) : data;
	}, [searchString, data]);

	const handleSelectAllData = useCallback(() => {
		const isCheckedAllItems = data.every((el) => selectedModifierGroupsAsAdditional.includes(el.id));
		const dataIDs = data.map((el) => el.id);
		if (isCheckedAllItems) {
			setModifierGroupsAsAdditional(selectedModifierGroupsAsAdditional.filter((el) => !dataIDs.includes(el)));
		} else {
			const filteredData = data
				.map((el) => el.id)
				.filter((el) => !selectedModifierGroupsAsAdditional.includes(el));
			setModifierGroupsAsAdditional([...selectedModifierGroupsAsAdditional, ...filteredData]);
		}
	}, [data, selectedModifierGroupsAsAdditional, setModifierGroupsAsAdditional]);

	useEffect(() => {
		setSearchString('');
	}, [selectedModifierGroups]);

	const renderSelectMenu = useCallback(
		(menu: React.ReactElement) => {
			const isChecked = () => {
				return data.every((el) => selectedModifierGroupsAsAdditional.includes(el.id));
			};

			return (
				<>
					<div className={style.selectMenuHeader}>
						<Checkbox
							className={style.checkBox}
							checked={!!(data.length && isChecked())}
							disabled={!data.length}
							onChange={handleSelectAllData}>
							<Text
								translationNameSpace="form"
								translationKey="selectAllModifierGroupsLabel"
								asFragment={true}
							/>
						</Checkbox>
						<SearchField
							onChangeSelectSearchString={setSearchString}
							searchString={searchString}
							className={style.searchField}
						/>
					</div>
					{menu}
				</>
			);
		},
		[data, selectedModifierGroupsAsAdditional, handleSelectAllData, setSearchString, searchString],
	);

	return (
		<FormSelect
			name="selectedModifierGroupsAsAdditional"
			label="useAsAdditionalLabel"
			options={filteredData}
			disabled={!selectedModifierGroups.length}
			onChange={setModifierGroupsAsAdditional}
			counterValue={selectedModifierGroupsAsAdditional.length}
			dropdownRender={renderSelectMenu}
			mode="multiple"
		/>
	);
};

export default React.memo(MultipleSelect);
